import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IPartialGradeQuery } from 'app/library/partial-grade/interfaces/partial-grade.query.interface';
import { PartialGrade } from 'app/library/partial-grade/models/partial-grade.model';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ModulePartialGradesService {
    constructor(private http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) private environment: IEnvironment) {}

    getAll(moduleId: string): Observable<PartialGrade[]> {
        return this.http
            .get<IPartialGradeQuery[]>(`${this.environment.apiUrl}/modules/${moduleId}/partial-grades/manager`)
            .pipe(map((queries) => queries.map((query) => new PartialGrade(query))));
    }
}
